import buildComponent from './utils/build-component';
import setParentWhenLoaded from './set-parent-when-loaded';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initFunction: ($el, params) => {

    //
    // Methods
    //

    //
    // Life Cycle
    //

    //
    // Procedures
    //

    setParentWhenLoaded(nameSpace).init({
      $el,
    });

    //
    // Listeners / Observers
    //

    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/article-card.js